import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

import { darkTheme } from './styles/dark-theme';
import { SupplierProvider } from './context/SupplierContext';
import { AppLayout } from './components';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import Listings from './pages/Listings';
import Orders from './pages/Orders';
import Settings from './pages/Settings';

// 设置 dayjs 语言
dayjs.locale('zh-cn');

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN} theme={darkTheme}>
      <AntdApp>
        <SupplierProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<AppLayout />}>
                <Route index element={<Navigate to="/products" replace />} />
                <Route path="products" element={<ProductList />} />
                <Route path="products/:sku" element={<ProductDetail />} />
                <Route path="listings" element={<Listings />} />
                <Route path="orders" element={<Orders />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </SupplierProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

export default App;
